import { combineReducers } from 'redux';
import * as auth from '../../../modules/auth';
import createCampaignSlice from '../slices/campaigns/create-campaign-slice';

export const rootReducer = combineReducers({
  auth: auth.reducer,
  campaigns : createCampaignSlice
});

export type RootState = ReturnType<typeof rootReducer>;
